import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, mergeProps as _mergeProps, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "alert alert-warning ml-4"
};
const _hoisted_2 = {
  class: "ml-4"
};
const _hoisted_3 = ["onClick"];
const _hoisted_4 = {
  class: "d-flex align-center"
};
const _hoisted_5 = {
  key: 1,
  src: "/img/qb16x16.png",
  class: "mr-1"
};
const _hoisted_6 = {
  class: "d-flex align-center"
};
const _hoisted_7 = {
  key: 1,
  src: "/img/qb16x16.png",
  class: "mr-1"
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 1
};
const _hoisted_10 = {
  class: "flex w-full"
};
const _hoisted_11 = {
  key: 0
};
const _hoisted_12 = {
  key: 0,
  style: {
    "margin-top": "-10px",
    "margin-left": "26px"
  }
};
const _hoisted_13 = {
  key: 0
};
const _hoisted_14 = {
  class: "grid"
};
const _hoisted_15 = {
  key: 0,
  class: "mt-4"
};
const _hoisted_16 = {
  class: "d-flex flex-wrap flex-column"
};
const _hoisted_17 = {
  class: "d-flex flex-row p-0 w-full"
};
const _hoisted_18 = {
  key: 1
};
const _hoisted_19 = {
  key: 0,
  class: "mt-8 ml-4 mb-4"
};
const _hoisted_20 = {
  class: "span6"
};
const _hoisted_21 = {
  class: "row-fluid"
};
const _hoisted_22 = {
  class: "row-fluid"
};
const _hoisted_23 = {
  class: "span6"
};
const _hoisted_24 = {
  class: "span6"
};
const _hoisted_25 = {
  class: "row-fluid"
};
const _hoisted_26 = {
  class: "span6"
};
import { ref, reactive, onMounted, computed } from 'vue';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlButtonToggle from '@/components/LlButtonToggle.vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import ProductNotice from '@/components/ProductNotice.vue';
import RouteService from '@/services/RouteService';
import LlTooltip from '@/components/LlTooltip.vue';
import SettingsSaveBar from '@/components/SettingsSaveBar.vue';
import { useTrustAccountingStore } from '@/services/trustAccountingStore.js';
import EditTrustAccountDialog from './EditTrustAccountDialog.vue';
import Loader from '@/components/Loader.vue';
import LlCheckbox from '@/components/LlCheckbox.vue';
import { useGravityValidationStore } from '@/services/useGravityValidationStore';
import { useCompanyStore } from '@/services/UserService/useCompanyStore';
import { useSupportChat } from '@/composables/useSupportChat';
export default {
  __name: 'TrustAccounting',
  props: {
    alerts: {
      type: Object,
      required: true
    },
    accountingService: {
      type: Object,
      required: true
    },
    rootScope: {
      type: Object,
      required: true
    },
    state: {
      type: Object,
      required: true
    },
    userService: {
      type: Object,
      required: true
    },
    tracking: {
      type: Object,
      required: true
    }
  },
  setup(__props) {
    const {
      getSupportUrl
    } = useSupportChat();
    const props = __props;
    const {
      getMe
    } = useMeStore();
    const {
      me,
      features,
      company
    } = storeToRefs(useMeStore());
    const {
      validateConfidoEnabled
    } = useGravityValidationStore();
    const {
      confidoValidation
    } = storeToRefs(useGravityValidationStore());
    const {
      companySettings
    } = storeToRefs(useCompanyStore());
    const {
      loadMyCompany
    } = useCompanyStore();
    const trustAccountingState = reactive({
      loading: false,
      loadingSpinner: false,
      operatingAccountList: [],
      unDepositedFundList: [],
      column: null,
      toggle: undefined,
      me: {},
      vendor: null,
      vendors: [],
      accounts: [],
      paymentType: 'normal',
      unsaved: false,
      saving: false,
      openTrustDialog: false,
      gravityStatus: false,
      formData: {
        selectedOperatingAccount: {},
        selectedProductService: {},
        selectedEvergreenProductService: '',
        selectedUnDepositedFund: {},
        selectedTrust: false,
        isTrustMemoEnabled: false,
        accounts: [],
        unDepositedFund: false,
        printLater: false,
        evergreen: false,
        automate: false,
        selectedFullPaymentNotice: '',
        config: {
          custom: false,
          memoPattern: '',
          memoPatternPartial: '',
          memoPatternEvergreen: ''
        }
      }
    });
    const originalFormData = ref({});
    const evergreenProductServices = ref([]);
    const trustAccountingStore = useTrustAccountingStore();
    trustAccountingStore.alerts = props.alerts;
    onMounted(async () => {
      await loadMyCompany();
      trustAccountingState.gravityStatus = companySettings.value.gravity || {};
      trustAccountingState.loading = true;
      await getMe();
      trustAccountingState.gravityStatus.enabled && (await validateConfidoEnabled());
      await trustAccountingStore.load(true, me.value);
      await trustAccountingStore.accountingListVendors();
      confidoValidation.value?.validToken && (await trustAccountingStore.loadConfidoTrustAccounts());
      trustAccountingState.vendors = [...trustAccountingStore.vendors];
      const {
        automate,
        trustConfig,
        isTrustMemoEnabled
      } = trustAccountingStore.settings;
      trustAccountingState.accountingAccounts = trustAccountingStore.accountingAccounts || [];
      trustAccountingState.accounts = trustAccountingStore.accounts || [];
      trustAccountingState.operatingAccountList = trustAccountingStore.accountingAccounts.operating;
      trustAccountingState.unDepositedFundList = trustAccountingStore.accountingAccounts.undeposited;
      trustAccountingState.formData.automate = automate;
      trustAccountingState.formData.isTrustMemoEnabled = isTrustMemoEnabled || false;
      trustAccountingState.config = trustConfig || {};
      trustAccountingState.formData.config = trustConfig || {};
      if (features.value?.evergreenPlus) {
        props.accountingService.services().then(({
          services
        }) => {
          evergreenProductServices.value.push(...services);
        });
      }
      const deactivate = new RouteService(props).rootScopeChange().$on('$stateChangeStart', event => {
        if (somethingChanged.value) {
          trustAccountingState.unsaved = true;
          setTimeout(() => {
            trustAccountingState.unsaved = false;
          }, 4000);
          event.preventDefault();
        } else {
          deactivate();
        }
      });
      trustAccountingState.formData = resetForm();
      originalFormData.value = JSON.parse(JSON.stringify(trustAccountingState.formData));
      trustAccountingState.loading = false;
    });
    function resetForm() {
      const hasDeposits = trustAccountingStore.settings?.deposits && Object.keys(trustAccountingStore.settings?.deposits).length > 0;
      return {
        selectedOperatingAccount: trustAccountingStore.settings?.operating,
        selectedEvergreenProductService: trustAccountingStore.settings?.evergreenService,
        selectedProductService: trustAccountingStore.settings?.paymentVendor,
        selectedUnDepositedFund: trustAccountingStore.settings?.deposits,
        printLater: trustAccountingStore.settings?.printLater,
        evergreen: trustAccountingStore.settings?.evergreen,
        automate: trustAccountingStore.settings?.automate,
        isTrustMemoEnabled: trustAccountingStore.settings?.isTrustMemoEnabled,
        selectedTrust: trustAccountingState.formData.selectedTrust,
        unDepositedFund: hasDeposits,
        config: {
          custom: trustAccountingState.config?.custom,
          memoPattern: trustAccountingState.config?.memoPattern,
          memoPatternPartial: trustAccountingState.config?.memoPatternPartial,
          memoPatternEvergreen: trustAccountingState.config?.memoPatternEvergreen
        }
      };
    }
    const toggleTrust = value => {
      trustAccountingState.formData.automate = value;
    };
    const customChange = value => {
      if (value) {
        trustAccountingState.formData.config.custom = value;
        return;
      }
    };
    const toggleDialog = () => {
      trustAccountingState.dialog = !trustAccountingState.dialog;
    };
    const noticeBackToDefault = () => {
      // These values are copied from CompanyDetailFrom.cs, which is only used when the company is first created
      const normal = 'Retainer information:\n' + '+ Previous account balance: {AccountBefore}\n' + '+ New charges: {InvoiceAmount}\n' + '- Previous retainer balance: {TrustBefore}\n' + '- Payment made from retainer: {TrustPayment}\n' + '= New account balance: {AccountAfter}\n' + '= New retainer balance: {TrustAfter}\n';
      const evergreen = normal + '= Minimum retainer required: {TrustEvergreen}\n' + '= Payment required: {PaymentRequired}\n';
      trustAccountingState.formData.config.custom = false;
      trustAccountingState.formData.config.memoPattern = normal;
      trustAccountingState.formData.config.memoPatternPartial = normal;
      trustAccountingState.formData.config.memoPatternEvergreen = evergreen;
      trustAccountingState.dialog = false;
    };
    const memo = type => {
      if (type) {
        const values = {
          normal: {
            accountBalance: 1000,
            trustBalance: 2500,
            invoiceBalance: 3000
          },
          partial: {
            accountBalance: 1000,
            trustBalance: 10000,
            invoiceBalance: 3000
          },
          evergreen: {
            accountBalance: 1000,
            trustBalance: 8000,
            invoiceBalance: 3000,
            evergreen: 10000
          }
        };
        const params = values[type];
        params.config = trustAccountingState.formData?.config;
        if (me.value && company?.value.settings?.trustEnabled && trustAccountingState.formData?.config) {
          return trustAccountingStore.trustMemo(params);
        }
      }
      return '';
    };

    /** The payment types the preview can be switched between. */
    const memoPreviewTypes = computed(() => trustAccountingState.formData?.evergreen ? ['normal', 'partial', 'evergreen'] : ['normal', 'partial']);
    const PAYMENT_TYPE_LABELS = {
      normal: 'Full Payment',
      partial: 'Partial Payment',
      evergreen: 'Evergreen'
    };
    const paymentTypeItems = computed(() => memoPreviewTypes.value.map(value => ({
      label: PAYMENT_TYPE_LABELS[value],
      value
    })));
    function cancel() {
      trustAccountingState.formData = resetForm();
    }
    const update = async () => {
      const {
        selectedOperatingAccount,
        selectedProductService,
        selectedEvergreenProductService,
        selectedTrust,
        selectedUnDepositedFund,
        printLater,
        evergreen,
        automate,
        isTrustMemoEnabled
      } = trustAccountingState.formData;
      if (!selectedOperatingAccount || Object.keys(selectedOperatingAccount).length === 0) {
        props.alerts?.error('Please select an operating account.');
        return;
      }
      if (!trustAccountingState.formData?.selectedProductService || Object.keys(trustAccountingState.formData.selectedProductService).length === 0) {
        return props.alerts?.error('Payment vendor is required. It is used when making payments from trust accounts');
      }
      try {
        trustAccountingState.saving = true;
        await trustAccountingStore.updateSettings(selectedOperatingAccount, selectedUnDepositedFund, trustAccountingState.formData.config, evergreen, selectedEvergreenProductService, printLater, selectedProductService, automate, isTrustMemoEnabled);
        props.alerts?.success('Settings updated successfully.');
        trustAccountingState.saving = false;
        originalFormData.value = JSON.parse(JSON.stringify(trustAccountingState.formData));
      } catch (error) {
        trustAccountingState.saving = false;
        props.alerts?.error('Error in updating settings', error);
      }
    };
    const somethingChanged = computed(() => {
      return JSON.stringify(trustAccountingState.formData) !== JSON.stringify(originalFormData.value);
    });
    const isTrustAccountBroken = status => ['inactive', 'deleted'].includes((status || '').toLowerCase());
    const trustAccountStatusLabel = status => (status || '').toLowerCase() === 'deleted' ? 'Deleted' : 'Inactive';
    const trustAccountStatusTooltip = (name, status) => {
      const accountName = name || 'This account';
      return (status || '').toLowerCase() === 'deleted' ? `${accountName} was deleted in QuickBooks. Edit this trust account and choose a different account, or recreate it in QuickBooks.` : `${accountName} is inactive in QuickBooks. Reactivate it in QuickBooks, or edit this trust account and choose a different account.`;
    };
    const editTrust = trust => {
      trustAccountingState.openTrustDialog = !trustAccountingState.openTrustDialog;
      trustAccountingState.editingTrust = trust;
    };
    const cancelDialog = () => {
      trustAccountingState.dialog = false;
    };
    const addAnotherTrustAccount = () => {
      trustAccountingState.openTrustDialog = !trustAccountingState.openTrustDialog;
      trustAccountingState.editingTrust = {};
    };
    const addNewTrustAccount = () => {
      trustAccountingState.openTrustDialog = !trustAccountingState.openTrustDialog;
      trustAccountingState.editingTrust = {};
    };
    const closeEditTrustAccountDialog = () => {
      trustAccountingState.openTrustDialog = false;
    };
    const reload = async trust => {
      trustAccountingState.openTrustDialog = false;
      trustAccountingState.loadingSpinner = true;
      await trustAccountingStore.load(true, me.value);
      props.alerts?.success('Trust account updated successfully.');
      trustAccountingState.accounts = trustAccountingStore.accounts;
      trustAccountingState.loadingSpinner = false;
    };
    const learnMore = () => {
      props.state.go('settings.company.billing');
    };
    const createFirmVendor = async () => {
      const vendor = await trustAccountingStore.accountingCreateFirmVendor();
      trustAccountingState.formData.selectedProductService = vendor;
      trustAccountingStore.settings.paymentVendor = vendor;
      trustAccountingState.formData.selectedProductService.type = 'Vendor';
      trustAccountingState.vendors.push(vendor);
    };
    const support = () => {
      window.open(getSupportUrl('trustPayeeSetup'), '_blank', 'noopener,noreferrer');
    };

    // v-model owns the checkbox value; this only keeps the dependent account in
    // step. It ran before v-model back when the handler was a native @click, so it
    // used to flip the value itself — doing that now double-toggles.
    const onUnDepositedFundChange = () => {
      trustAccountingState.formData.selectedUnDepositedFund = trustAccountingState.formData.unDepositedFund ? trustAccountingState.unDepositedFundList[0] : {};
    };
    return (_ctx, _cache) => {
      const _component_v_card_title = _resolveComponent("v-card-title");
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_chip = _resolveComponent("v-chip");
      const _component_v_tooltip = _resolveComponent("v-tooltip");
      const _component_v_table = _resolveComponent("v-table");
      const _component_v_col = _resolveComponent("v-col");
      const _component_v_card_text = _resolveComponent("v-card-text");
      const _component_v_autocomplete = _resolveComponent("v-autocomplete");
      const _component_v_radio = _resolveComponent("v-radio");
      const _component_v_card = _resolveComponent("v-card");
      const _component_v_radio_group = _resolveComponent("v-radio-group");
      const _component_v_row = _resolveComponent("v-row");
      const _component_v_textarea = _resolveComponent("v-textarea");
      const _component_v_divider = _resolveComponent("v-divider");
      const _component_v_card_actions = _resolveComponent("v-card-actions");
      const _component_v_dialog = _resolveComponent("v-dialog");
      const _component_v_container = _resolveComponent("v-container");
      return trustAccountingState.loading ? (_openBlock(), _createBlock(Loader, {
        key: 0,
        what: 'Trust Accounting',
        class: "mt-32"
      })) : (_openBlock(), _createBlock(_component_v_container, {
        key: 1
      }, {
        default: _withCtx(() => [_createVNode(_component_v_row, null, {
          default: _withCtx(() => [_createVNode(_component_v_col, {
            cols: "12",
            md: "12"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("Trust Account Setup", -1)]))]),
              _: 1
            }), trustAccountingState.loadingSpinner ? (_openBlock(), _createBlock(_component_v_progress_circular, {
              key: 0,
              color: "success",
              indeterminate: ""
            })) : _createCommentVNode("", true), _withDirectives(_createElementVNode("div", null, [_createElementVNode("div", _hoisted_1, [_cache[18] || (_cache[18] = _createElementVNode("p", null, [_createElementVNode("b", null, "QuickBooks is not connected")], -1)), _cache[19] || (_cache[19] = _createElementVNode("p", null, " Trust accounting requires a connection to QuickBooks. Please go to the QuickBooks Integration settings to set it up. ", -1)), _createVNode(LlSecondaryButton, {
              color: "primary",
              onClick: learnMore
            }, {
              default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode(" Learn More ", -1)]))]),
              _: 1
            })])], 512), [[_vShow, !trustAccountingState.loading && !_unref(trustAccountingStore)?.connected]]), _withDirectives(_createElementVNode("div", null, [_withDirectives(_createElementVNode("div", _hoisted_2, [...(_cache[20] || (_cache[20] = [_createElementVNode("p", null, "You don't have trust accounting set up in the system.", -1), _createElementVNode("p", null, "The first step is to configure your operating account:", -1)]))], 512), [[_vShow, !_unref(trustAccountingStore).configured]]), _withDirectives(_createElementVNode("div", null, [_withDirectives(_createElementVNode("div", null, [...(_cache[21] || (_cache[21] = [_createElementVNode("p", {
              class: "ml-4"
            }, " Add an account to connect or create a Trust bank account and a corresponding liablity account in the accounting system. This is how you keep track of trust funds for clients ", -1)]))], 512), [[_vShow, !trustAccountingState.accounts?.length && !trustAccountingState.loadingSpinner]]), _withDirectives(_createElementVNode("div", null, [_createVNode(_component_v_table, {
              density: "compact"
            }, {
              default: _withCtx(() => [_cache[24] || (_cache[24] = _createElementVNode("thead", null, [_createElementVNode("tr", null, [_createElementVNode("th", {
                class: "text-left"
              }, "Label"), _createElementVNode("th", {
                class: "text-left"
              }, "Bank Account"), _createElementVNode("th", {
                class: "text-left"
              }, "Liability Account")])], -1)), _createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trustAccountingState?.accounts, trust => {
                return _openBlock(), _createElementBlock("tr", {
                  key: trust.name,
                  onClick: $event => editTrust(trust),
                  class: "cursor-pointer"
                }, [_createElementVNode("td", null, _toDisplayString(trust.label), 1), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_4, [isTrustAccountBroken(trust.bankStatus) ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  location: "top",
                  "max-width": "320"
                }, {
                  activator: _withCtx(({
                    props
                  }) => [_createVNode(_component_v_chip, _mergeProps({
                    ref_for: true
                  }, props, {
                    color: "error",
                    size: "small",
                    variant: "flat",
                    label: "",
                    class: "mr-2",
                    tabindex: "0"
                  }), {
                    default: _withCtx(() => [_createVNode(_component_v_icon, {
                      start: "",
                      size: "small"
                    }, {
                      default: _withCtx(() => [...(_cache[22] || (_cache[22] = [_createTextVNode("mdi-alert-circle-outline", -1)]))]),
                      _: 1
                    }), _createTextVNode(" " + _toDisplayString(trustAccountStatusLabel(trust.bankStatus)), 1)]),
                    _: 2
                  }, 1040)]),
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(trustAccountStatusTooltip(trust?.bank?.name, trust.bankStatus)), 1)]),
                  _: 2
                }, 1024)) : (_openBlock(), _createElementBlock("img", _hoisted_5)), _createElementVNode("span", null, _toDisplayString(trust?.bank?.name), 1)])]), _createElementVNode("td", null, [_createElementVNode("div", _hoisted_6, [isTrustAccountBroken(trust.liabilityStatus) ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  location: "top",
                  "max-width": "320"
                }, {
                  activator: _withCtx(({
                    props
                  }) => [_createVNode(_component_v_chip, _mergeProps({
                    ref_for: true
                  }, props, {
                    color: "error",
                    size: "small",
                    variant: "flat",
                    label: "",
                    class: "mr-2",
                    tabindex: "0"
                  }), {
                    default: _withCtx(() => [_createVNode(_component_v_icon, {
                      start: "",
                      size: "small"
                    }, {
                      default: _withCtx(() => [...(_cache[23] || (_cache[23] = [_createTextVNode("mdi-alert-circle-outline", -1)]))]),
                      _: 1
                    }), _createTextVNode(" " + _toDisplayString(trustAccountStatusLabel(trust.liabilityStatus)), 1)]),
                    _: 2
                  }, 1040)]),
                  default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(trustAccountStatusTooltip(trust.liability?.name, trust.liabilityStatus)), 1)]),
                  _: 2
                }, 1024)) : (_openBlock(), _createElementBlock("img", _hoisted_7)), _createElementVNode("span", null, _toDisplayString(trust.liability?.name), 1)])])], 8, _hoisted_3);
              }), 128))])]),
              _: 1
            })], 512), [[_vShow, trustAccountingState.accounts?.length > 0]]), trustAccountingState.accounts?.length && _unref(features)?.trustAdvanced ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(LlSecondaryButton, {
              class: "ml-4",
              onClick: addAnotherTrustAccount
            }, {
              default: _withCtx(() => [...(_cache[25] || (_cache[25] = [_createTextVNode(" Add Another Trust Account ", -1)]))]),
              _: 1
            })])) : _createCommentVNode("", true), !trustAccountingState.accounts?.length && !trustAccountingState.loadingSpinner ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(LlSecondaryButton, {
              color: "primary",
              class: "ml-4",
              onClick: addNewTrustAccount
            }, {
              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [_createTextVNode(" Add Trust Account ", -1)]))]),
              _: 1
            })])) : _createCommentVNode("", true)], 512), [[_vShow, _unref(trustAccountingStore).configured]])], 512), [[_vShow, _unref(trustAccountingStore)?.connected]])]),
            _: 1
          }), _withDirectives(_createElementVNode("div", _hoisted_10, [_createVNode(_component_v_col, {
            cols: "12",
            md: "6"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[27] || (_cache[27] = [_createTextVNode("Operating Account ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_text, {
              class: "text-medium-emphasis text-caption p-0"
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [_createTextVNode(" This is used when making payments from trust accounts to your firm ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_text, {
              class: "d-flex p-0 w-2/3"
            }, {
              default: _withCtx(() => [_cache[29] || (_cache[29] = _createElementVNode("img", {
                src: "/img/qb16x16.png",
                class: "quickbooks-logo mr-1"
              }, null, -1)), _createVNode(_component_v_autocomplete, {
                modelValue: trustAccountingState.formData.selectedOperatingAccount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => trustAccountingState.formData.selectedOperatingAccount = $event),
                items: trustAccountingState.operatingAccountList,
                "item-title": item => item.name,
                "item-value": "id",
                density: "compact",
                placeholder: "Select an operating account",
                "return-object": "",
                variant: "outlined",
                color: "primary",
                class: "p-0 w-full",
                "hide-details": "true"
              }, null, 8, ["modelValue", "items", "item-title"])]),
              _: 1
            }), !trustAccountingState.operatingAccountList.length ? (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[30] || (_cache[30] = [_createElementVNode("p", null, [_createElementVNode("span", {
              class: "fa fa-warning"
            }), _createTextVNode(" You do not currently have a bank account set up in QuickBooks, we will create one for you called 'Operating Account' ")], -1)]))])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [_createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[31] || (_cache[31] = [_createTextVNode("Trust Payee Vendor", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_text, {
              class: "text-medium-emphasis text-caption"
            }, {
              default: _withCtx(() => [_cache[34] || (_cache[34] = _createElementVNode("p", null, " The QuickBooks Vendor selected below will be used as the payee for all trust payments recorded in LeanLaw. This should be set to a Vendor that represents your firm. ", -1)), _createElementVNode("p", null, [_cache[33] || (_cache[33] = _createTextVNode(" Note: QuickBooks does not allow a Vendor to share a display name with a Customer or Employee ", -1)), _createElementVNode("span", {
                onClick: support,
                class: "cursor-pointer"
              }, [_createVNode(LlTooltip, {
                icon: "help"
              }, {
                default: _withCtx(() => [...(_cache[32] || (_cache[32] = [_createTextVNode(" Link to support ", -1)]))]),
                _: 1
              })])])]),
              _: 1
            }), _createVNode(_component_v_col, {
              class: "pa-0"
            }, {
              default: _withCtx(() => [_createVNode(_component_v_card_text, {
                class: "d-flex flex-row p-0 w-2/3"
              }, {
                default: _withCtx(() => [_cache[35] || (_cache[35] = _createElementVNode("img", {
                  src: "/img/qb16x16.png",
                  class: "quickbooks-logo mr-1"
                }, null, -1)), _createVNode(_component_v_autocomplete, {
                  items: trustAccountingState.vendors,
                  modelValue: trustAccountingState.formData.selectedProductService,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => trustAccountingState.formData.selectedProductService = $event),
                  "item-title": item => item.displayName || item.name,
                  "item-value": "id",
                  density: "compact",
                  variant: "outlined",
                  class: "account-select",
                  "return-object": "",
                  clearable: "",
                  searchable: "",
                  placeholder: "Select vendors",
                  color: "primary",
                  "hide-details": "true"
                }, null, 8, ["items", "modelValue", "item-title"])]),
                _: 1
              }), !trustAccountingState.formData?.selectedProductService || Object.keys(trustAccountingState.formData?.selectedProductService).length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(LlSecondaryButton, {
                onClick: createFirmVendor,
                title: "When we Create a vendor we create a new QuickBooks Online Vendor with the firm's name."
              }, {
                default: _withCtx(() => [...(_cache[36] || (_cache[36] = [_createTextVNode(" Create Vendor ", -1)]))]),
                _: 1
              })])) : _createCommentVNode("", true)]),
              _: 1
            })]), _unref(trustAccountingStore).configured && trustAccountingState.accounts?.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[37] || (_cache[37] = [_createTextVNode("Invoice Trust Notice ", -1)]))]),
              _: 1
            }), _createVNode(_component_v_card_text, {
              class: "text-medium-emphasis text-caption"
            }, {
              default: _withCtx(() => [_cache[38] || (_cache[38] = _createElementVNode("p", null, " This notice will be added to invoice memo fields (sample amounts): ", -1)), _createVNode(LlCheckbox, {
                label: "Add Trust Memo to Invoice",
                modelValue: trustAccountingState.formData.isTrustMemoEnabled,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => trustAccountingState.formData.isTrustMemoEnabled = $event),
                info: "When enabled the Invoice Trust Notice will be injected in your firm's invoice memos."
              }, null, 8, ["modelValue"])]),
              _: 1
            }), _createVNode(LlButtonToggle, {
              modelValue: trustAccountingState.paymentType,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => trustAccountingState.paymentType = $event),
              items: paymentTypeItems.value,
              "aria-label": "Trust notice payment type"
            }, null, 8, ["modelValue", "items"]), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(memoPreviewTypes.value, type => {
              return _openBlock(), _createElementBlock("pre", {
                key: type,
                class: "col-start-1 row-start-1",
                style: _normalizeStyle({
                  fontSize: '0.9em',
                  visibility: type === trustAccountingState.paymentType ? 'visible' : 'hidden'
                })
              }, _toDisplayString(memo(type)), 5);
            }), 128))]), !trustAccountingState.formData?.config?.custom ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createVNode(LlSecondaryButton, {
              variant: "tonal",
              onClick: _cache[4] || (_cache[4] = $event => customChange(true))
            }, {
              default: _withCtx(() => [...(_cache[39] || (_cache[39] = [_createTextVNode(" Customize ", -1)]))]),
              _: 1
            })])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
            _: 1
          }), _withDirectives(_createVNode(_component_v_col, {
            cols: "12",
            md: "6",
            class: "d-flex flex-column"
          }, {
            default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [...(_cache[40] || (_cache[40] = [_createTextVNode("Trust Options", -1)]))]),
              _: 1
            }), _createVNode(_component_v_row, {
              class: "ml-4"
            }, {
              default: _withCtx(() => [_unref(features)?.trustLiveOption ? (_openBlock(), _createBlock(_component_v_radio_group, {
                key: 0,
                modelValue: trustAccountingState.formData.selectedTrust,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => trustAccountingState.formData.selectedTrust = $event),
                column: ""
              }, {
                default: _withCtx(() => [_createVNode(_component_v_col, {
                  cols: "6"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_card, {
                    outlined: "",
                    tile: "",
                    class: _normalizeClass(["frozen-trust", {
                      'inactive-trust': trustAccountingState.formData.automate,
                      'active-trust': !trustAccountingState.formData.automate
                    }]),
                    onClick: _cache[5] || (_cache[5] = $event => toggleTrust(false))
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_radio, {
                      label: "Frozen Trust",
                      value: trustAccountingState.formData.automate,
                      class: "p-0 text-base font-medium",
                      color: 'primary'
                    }, null, 8, ["value"]), _createVNode(_component_v_card_text, {
                      class: "text-medium-emphasis text-caption pt-0"
                    }, {
                      default: _withCtx(() => [...(_cache[41] || (_cache[41] = [_createElementVNode("p", null, " All trust payments must be recorded manually. Confido Legal payment links automatically create payments in QuickBooks when payment is received. ", -1)]))]),
                      _: 1
                    }), _createVNode(_component_v_card_text, {
                      class: "text-medium-emphasis text-caption pt-0"
                    })]),
                    _: 1
                  }, 8, ["class"])]),
                  _: 1
                }), _createVNode(_component_v_col, {
                  cols: "6"
                }, {
                  default: _withCtx(() => [_createVNode(_component_v_card, {
                    outlined: "",
                    tile: "",
                    class: _normalizeClass({
                      'inactive-trust': !trustAccountingState.formData.automate,
                      'active-trust': trustAccountingState.formData.automate
                    }),
                    onClick: _cache[6] || (_cache[6] = $event => toggleTrust(true))
                  }, {
                    default: _withCtx(() => [_createVNode(_component_v_radio, {
                      label: "Live Trust",
                      value: !trustAccountingState.formData.automate,
                      class: "p-0 text-base font-medium",
                      color: 'primary'
                    }, null, 8, ["value"]), _createVNode(_component_v_card_text, {
                      class: "text-medium-emphasis text-caption pt-0"
                    }, {
                      default: _withCtx(() => [...(_cache[42] || (_cache[42] = [_createElementVNode("p", null, " Upon reaching QuickBooks, invoices are automatically paid from available trust funds. Confido Legal payment links for matters with trust are recorded as trust deposits. ", -1)]))]),
                      _: 1
                    })]),
                    _: 1
                  }, 8, ["class"])]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue"])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_16, [_createVNode(LlCheckbox, {
                modelValue: trustAccountingState.formData.printLater,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => trustAccountingState.formData.printLater = $event),
                label: "Mark checks as \"Print Later\"",
                info: "When recording trust payments, a \"check\" transaction is created in QuickBooks. Enable this option to mark those checks with \"Print Later\"."
              }, null, 8, ["modelValue"]), _createVNode(LlCheckbox, {
                modelValue: trustAccountingState.formData.unDepositedFund,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => trustAccountingState.formData.unDepositedFund = $event),
                label: "Use Undeposited Funds Account",
                onCheckboxClick: onUnDepositedFundChange
              }, null, 8, ["modelValue"]), trustAccountingState.formData.unDepositedFund ? (_openBlock(), _createBlock(_component_v_card_text, {
                key: 0,
                class: "d-flex flex-row p-0 w-full"
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_17, [_cache[43] || (_cache[43] = _createElementVNode("img", {
                  src: "/img/qb16x16.png",
                  class: "quickbooks-logo mr-1"
                }, null, -1)), _createVNode(_component_v_autocomplete, {
                  items: trustAccountingState.unDepositedFundList,
                  modelValue: trustAccountingState.formData.selectedUnDepositedFund,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => trustAccountingState.formData.selectedUnDepositedFund = $event),
                  "item-title": item => `${item.name ? item.name : ''}`,
                  "item-value": "id",
                  density: "compact",
                  variant: "outlined",
                  class: "account-select",
                  "return-object": "",
                  clearable: "",
                  searchable: "",
                  placeholder: "Select un deposited funds",
                  color: "primary",
                  "hide-details": "true"
                }, null, 8, ["items", "modelValue", "item-title"])])]),
                _: 1
              })) : _createCommentVNode("", true), !_unref(trustAccountingStore).accountingAccounts?.undeposited?.length ? (_openBlock(), _createElementBlock("div", _hoisted_18, [...(_cache[44] || (_cache[44] = [_createElementVNode("p", null, " We don't see any undeposited funds accounts in QuickBooks. We will set it up for you. ", -1), _createElementVNode("p", null, [_createElementVNode("span", {
                class: "fa fa-warning"
              }), _createTextVNode(" If this is a mistake, make sure the account has the type 'Undeposited Funds' in QuickBooks and try again. ")], -1)]))])) : _createCommentVNode("", true)])]),
              _: 1
            }), !_unref(features)?.trustAdvanced ? (_openBlock(), _createElementBlock("div", _hoisted_19, [_createVNode(ProductNotice, {
              state: __props.state,
              label: 'Advanced trust options including Multiple Trust Accounts and Evergreens are',
              product: 'trustAdvanced'
            }, null, 8, ["state"])])) : _createCommentVNode("", true), _createVNode(_component_v_row, {
              class: "ml-4"
            }, {
              default: _withCtx(() => [_unref(features)?.trustAdvanced ? (_openBlock(), _createBlock(LlCheckbox, {
                key: 0,
                modelValue: trustAccountingState.formData.evergreen,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => trustAccountingState.formData.evergreen = $event),
                label: "Enable Evergreen Retainers",
                info: "This allows setting a minimum trust balance for clients/matters"
              }, null, 8, ["modelValue"])) : _createCommentVNode("", true)]),
              _: 1
            })]), _createVNode(_component_v_row, {
              class: "mt-auto flex-grow-0"
            }, {
              default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_20, [_cache[57] || (_cache[57] = _createTextVNode(" Fields to use when customizing trust notices: ", -1)), _createElementVNode("ul", null, [_cache[48] || (_cache[48] = _createElementVNode("li", null, [_createElementVNode("b", null, "{TrustBefore}"), _createTextVNode(" - Current trust balance")], -1)), _cache[49] || (_cache[49] = _createElementVNode("li", null, [_createElementVNode("b", null, "{TrustAfter}"), _createTextVNode(" - Trust balance after invoice is paid ")], -1)), _cache[50] || (_cache[50] = _createElementVNode("li", null, [_createElementVNode("b", null, "{TrustAfterSimple}"), _createTextVNode(" - Trust balance after invoice is paid (ignoring account balance) ")], -1)), _cache[51] || (_cache[51] = _createElementVNode("li", null, [_createElementVNode("b", null, "{InvoiceAmount}"), _createTextVNode(" - Invoice balance")], -1)), _cache[52] || (_cache[52] = _createElementVNode("li", null, [_createElementVNode("b", null, "{AccountBefore}"), _createTextVNode(" - Account balance before invoice")], -1)), _cache[53] || (_cache[53] = _createElementVNode("li", null, [_createElementVNode("b", null, "{AccountAfter}"), _createTextVNode(" - Account balance after invoice")], -1)), _cache[54] || (_cache[54] = _createElementVNode("li", null, [_createElementVNode("b", null, "{PaymentDue}"), _createTextVNode(" - Total amount due (invoice balance and account balance) ")], -1)), _cache[55] || (_cache[55] = _createElementVNode("li", null, [_createElementVNode("b", null, "{TrustPayment}"), _createTextVNode(" - How much will be deducted from retainer (either invoice balance plus account balance or trust balance) ")], -1)), _cache[56] || (_cache[56] = _createElementVNode("li", null, [_createElementVNode("b", null, "{TrustPaymentSimple}"), _createTextVNode(" - How much will be deducted from retainer (either invoice balance or trust balance) ")], -1)), _withDirectives(_createElementVNode("li", null, [...(_cache[45] || (_cache[45] = [_createElementVNode("b", null, "{TrustEvergreen}", -1), _createTextVNode(" - Evergreen amount (minimum balance) ", -1)]))], 512), [[_vShow, trustAccountingState.evergreen]]), _withDirectives(_createElementVNode("li", null, [...(_cache[46] || (_cache[46] = [_createElementVNode("b", null, "{TrustEvergreenReplenish}", -1), _createTextVNode(" - Evergreen replenish amount ", -1)]))], 512), [[_vShow, trustAccountingState.evergreen]]), _withDirectives(_createElementVNode("li", null, [...(_cache[47] || (_cache[47] = [_createElementVNode("b", null, "{PaymentRequired}", -1), _createTextVNode(" - Payment required to fill up evergreen account plus any additional account balance ", -1)]))], 512), [[_vShow, trustAccountingState.evergreen]])])], 512), [[_vShow, trustAccountingState.formData?.config?.custom]])]),
              _: 1
            })]),
            _: 1
          }, 512), [[_vShow, _unref(trustAccountingStore)?.connected]])], 512), [[_vShow, _unref(trustAccountingStore)?.connected]]), _createVNode(_component_v_col, {
            cols: "12",
            md: "12",
            class: "pa-0 ml-4"
          }, {
            default: _withCtx(() => [_withDirectives(_createElementVNode("div", _hoisted_21, [_createVNode(LlSecondaryButton, {
              onClick: toggleDialog
            }, {
              default: _withCtx(() => [...(_cache[58] || (_cache[58] = [_createTextVNode(" Set Edited Notices Back to Default ", -1)]))]),
              _: 1
            }), _cache[59] || (_cache[59] = _createElementVNode("h4", null, null, -1))], 512), [[_vShow, trustAccountingState.formData?.config?.custom]]), _withDirectives(_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[60] || (_cache[60] = _createElementVNode("p", null, "Edit Full Payment Notice", -1)), _createVNode(_component_v_textarea, {
              style: {
                "width": "95%"
              },
              rows: "12",
              color: 'primary',
              modelValue: trustAccountingState.formData.config.memoPattern,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => trustAccountingState.formData.config.memoPattern = $event),
              variant: "outlined",
              "hide-details": "true"
            }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_24, [_cache[61] || (_cache[61] = _createElementVNode("p", null, "Edit Partial Payment Notice", -1)), _createVNode(_component_v_textarea, {
              style: {
                "width": "95%"
              },
              rows: "12",
              color: 'primary',
              modelValue: trustAccountingState.formData.config.memoPatternPartial,
              "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => trustAccountingState.formData.config.memoPatternPartial = $event),
              variant: "outlined",
              "hide-details": "true"
            }, null, 8, ["modelValue"])])], 512), [[_vShow, trustAccountingState.formData?.config?.custom]]), _withDirectives(_createElementVNode("div", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_cache[62] || (_cache[62] = _createElementVNode("p", null, "Edit Evergreen Notice", -1)), _createVNode(_component_v_textarea, {
              style: {
                "width": "47%"
              },
              rows: "12",
              color: 'primary',
              modelValue: trustAccountingState.formData.config.memoPatternEvergreen,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => trustAccountingState.formData.config.memoPatternEvergreen = $event),
              variant: "outlined",
              "hide-details": "true"
            }, null, 8, ["modelValue"])])], 512), [[_vShow, trustAccountingState.formData.config?.custom && trustAccountingState.formData?.evergreen]])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_v_row, null, {
          default: _withCtx(() => [_createVNode(SettingsSaveBar, {
            somethingChanged: somethingChanged.value,
            saving: trustAccountingState.saving,
            unsaved: trustAccountingState.unsaved,
            onUpdate: update,
            onCancel: cancel
          }, null, 8, ["somethingChanged", "saving", "unsaved"])]),
          _: 1
        }), trustAccountingState.openTrustDialog ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0
        }, {
          default: _withCtx(() => [_createVNode(EditTrustAccountDialog, {
            alerts: __props.alerts,
            trustAccountingState: trustAccountingState,
            onCloseEditTrustAccountDialog: closeEditTrustAccountDialog,
            onCancel: cancelDialog,
            onReload: reload,
            tracking: __props.tracking
          }, null, 8, ["alerts", "trustAccountingState", "tracking"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_v_row, {
          justify: "center"
        }, {
          default: _withCtx(() => [_createVNode(_component_v_dialog, {
            transition: "dialog-top-transition",
            modelValue: trustAccountingState.dialog,
            "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => trustAccountingState.dialog = $event),
            width: "700"
          }, {
            default: _withCtx(() => [_createVNode(_component_v_card, null, {
              default: _withCtx(() => [_createVNode(_component_v_card_title, {
                class: "set-default-card-title"
              }, {
                default: _withCtx(() => [...(_cache[63] || (_cache[63] = [_createTextVNode("Do you want to reset trust notices back to the default?", -1)]))]),
                _: 1
              }), _createVNode(_component_v_divider), _createVNode(_component_v_card_actions, {
                class: "flex flex-1 justify-end bg-gray-50"
              }, {
                default: _withCtx(() => [_createVNode(LlSecondaryButton, {
                  onClick: cancelDialog
                }, {
                  default: _withCtx(() => [...(_cache[64] || (_cache[64] = [_createTextVNode("Cancel", -1)]))]),
                  _: 1
                }), _createVNode(LlSecondaryButton, {
                  color: "primary",
                  onClick: noticeBackToDefault,
                  variant: "text"
                }, {
                  default: _withCtx(() => [...(_cache[65] || (_cache[65] = [_createTextVNode(" Ok ", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }));
    };
  }
};